import { motion } from "framer-motion";
import { CONTACT } from "@/data/site";
import { MaskedLines } from "@/components/Kinetic";
import { EASE, viewport } from "@/lib/motion";

export const Footer = ({ onBrief }) => (
  <footer
    id="contact"
    data-testid="footer"
    className="relative border-t border-[#1f1f1f] bg-[#0a0a0a] pt-24 md:pt-40"
  >
    <div className="mx-auto max-w-[1700px] px-5 md:px-10">
      <span className="label text-[#7a7a7a]">FINAL FRAME</span>

      <MaskedLines
        lines={["GOT SOMETHING", "WORTH EDITING?"]}
        className="mt-8 font-display text-[11vw] font-black uppercase leading-[0.85] tracking-[-0.05em] text-[#e5e5e5] md:text-[7.4vw]"
        testId="footer-headline"
      />

      <MaskedLines
        lines={["LET'S MAKE IT MOVE."]}
        className="mt-4 font-display text-[11vw] font-black uppercase leading-[0.85] tracking-[-0.05em] text-[#d4ff00] md:text-[7.4vw]"
        delay={2}
      />

      <motion.button
        type="button"
        onClick={onBrief}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={viewport}
        transition={{ duration: 0.9, ease: EASE }}
        data-testid="footer-start-project"
        className="group relative mt-14 w-full overflow-hidden border border-[#d4ff00] px-8 py-8 md:w-auto md:px-16 md:py-10"
      >
        <span className="absolute inset-0 translate-y-full bg-[#d4ff00] transition-transform duration-600 ease-swift group-hover:translate-y-0" />
        <span className="relative font-display text-lg font-black uppercase tracking-tight text-[#d4ff00] transition-colors duration-300 group-hover:text-[#0a0a0a] md:text-2xl">
          START A PROJECT →
        </span>
      </motion.button>

      <div className="mt-24 grid gap-10 border-t border-[#1f1f1f] py-10 md:grid-cols-4">
        <div>
          <img src="/brand/hsk-logo.png" alt="HSK" className="h-6 w-auto" />
          <p className="mt-4 label text-[#a3a3a3]">HARSH KOTWANI</p>
          <p className="mt-1 label text-[#7a7a7a]">VIDEO EDITOR</p>
        </div>
        <div>
          <span className="label text-[#7a7a7a]">AVAILABILITY</span>
          <p data-testid="footer-worldwide" className="mt-3 label text-[#e5e5e5]">{CONTACT.availability}</p>
        </div>
        <div>
          <span className="label text-[#7a7a7a]">ELSEWHERE</span>
          <a
            href={CONTACT.instagramUrl}
            target="_blank"
            rel="noreferrer"
            data-cursor="open"
            data-testid="footer-instagram"
            className="group mt-3 flex w-fit items-center gap-2"
          >
            <span className="label text-[#e5e5e5] transition-colors group-hover:text-[#d4ff00]">
              INSTAGRAM
            </span>
            <span className="label text-[#7a7a7a]">{CONTACT.instagram}</span>
          </a>
        </div>
        <div>
          <span className="label text-[#7a7a7a]">SERVICES</span>
          <p className="mt-3 text-sm leading-relaxed text-[#a3a3a3]">
            Video editing / Short-form / Commercial & brand / Motion graphics /
            Graphic design / Creator content
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3 border-t border-[#1f1f1f] py-8 md:flex-row md:items-center md:justify-between">
        <span className="label text-[#4d4d4d]">
          © {new Date().getFullYear()} HSK® — ALL RIGHTS RESERVED
        </span>
        <span className="label text-[#4d4d4d]">
          GOOD FOOTAGE IS ONLY THE STARTING POINT.
        </span>
      </div>
    </div>
  </footer>
);
